import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { deepEqual } from './../../../utils';

class SelectionToggle extends Component {
  shouldComponentUpdate(nextProps) {
    return !deepEqual(this.props, nextProps);
  }

  getSelectionStatus() {
    if (this.props.isSelected === true) { return 'selected'; }
    if (this.props.isPartial === true) { return 'partial'; }

    if (this.props.selectedCount > 0) {
      if (this.props.allCount === this.props.selectedCount) {
        return 'selected';
      }
      return 'partial';
    }

    return 'none';
  }

  render() {
    const status = this.getSelectionStatus();
    const icon = status === 'partial'
      ? (<i className="md-icon">remove</i>)
      : (<i className="md-icon">fiber_manual_record</i>);

    return (
      <div
        className={`selection-toggle ${status}`}
        onClick={this.props.onToggleSelection}
        onKeyPress={this.props.onToggleSelection}
        role="button"
        tabIndex="0"
      >
        {icon}
      </div>
    );
  }
}

SelectionToggle.propTypes = {
  isSelected: PropTypes.bool,
  isPartial: PropTypes.bool,
  onToggleSelection: PropTypes.func.isRequired,
  allCount: PropTypes.number,
  selectedCount: PropTypes.number,
};

SelectionToggle.defaultProps = {
  isSelected: undefined,
  isPartial: undefined,
  allCount: undefined,
  selectedCount: undefined,
};

export default SelectionToggle;



// WEBPACK FOOTER //
// ./src/Shared/UI/SelectionToggle/SelectionToggle.js